import { getOptionValue } from './get-option-value';
export const getBasicCommonFilterSchema = _ref => {
  let {
    filterSchemas,
    option
  } = _ref;
  const optionValue = getOptionValue(option.value, option.from, option.to);
  return filterSchemas.find(filter => filter.buckets.find(bucket => {
    if (bucket?.options) {
      return bucket.code === option.code && bucket?.options.find(_ref2 => {
        let {
          value,
          from,
          to
        } = _ref2;
        return optionValue === getOptionValue(value, from, to);
      });
    }
    return bucket.code === option.code && optionValue === getOptionValue(bucket.value, bucket.from, bucket.to);
  }));
};